import { useEffect, useState, FC } from "react";

import "./dev.scss";
import { PartnerOrgSummary, listPartnerOrg } from "@rubi/api-generated";
import { Link } from "react-router-dom";

import { Breadcrumbs, Crumb, DevPage, ErrorMsg, Section } from "./common";

// `listPartnerOrg` only returns id/title (see `PartnerOrgSummary`), so unlike
// `DevOrgsPage`'s rows this can't pass the full model via route state — the
// detail page always fetches it itself via `getPartnerOrg`.
const PartnerOrgRow: FC<PartnerOrgSummary> = (partnerOrg) => {
  return (
    <tr>
      <td className="mono">
        <Link to={"./" + partnerOrg.id}>{partnerOrg.id}</Link>
      </td>
      <td>{partnerOrg.title}</td>
    </tr>
  );
};

const PartnerOrgTable: FC<{ partnerOrgs: PartnerOrgSummary[] }> = ({
  partnerOrgs,
}) => {
  return (
    <table className="dev-table">
      <thead>
        <tr>
          <th>id</th>
          <th>title</th>
        </tr>
      </thead>
      <tbody>
        {partnerOrgs.map((partnerOrg) => (
          <PartnerOrgRow key={partnerOrg.id} {...partnerOrg} />
        ))}
      </tbody>
    </table>
  );
};

export const DevPartnerOrgsPage: FC = () => {
  const [partnerOrgsList, setPartnerOrgsList] = useState<PartnerOrgSummary[]>(
    [],
  );
  const [loadErrorMsg, setLoadErrorMsg] = useState<string | null>(null);

  const loadPartnerOrgs = async () => {
    const response = await listPartnerOrg({ throwOnError: false });
    if (response.status === 200) {
      setPartnerOrgsList(response.data!.partner_orgs);
      setLoadErrorMsg(null);
    } else {
      setPartnerOrgsList([]);
      setLoadErrorMsg("" + response.status + " " + response.error?.console_msg);
    }
  };

  useEffect(() => {
    loadPartnerOrgs();
  }, []);

  return (
    <DevPage
      title="Partner Orgs"
      breadcrumbs={
        <Breadcrumbs>
          <Crumb>
            <Link to="/">Home</Link>
          </Crumb>
          <Crumb>
            <Link to="/dev_admin">Developer and Administrator Utilities</Link>
          </Crumb>
          <Crumb>Partner Orgs</Crumb>
        </Breadcrumbs>
      }
    >
      <Section>
        <Link to="/dev_admin/onboard_partner">Onboard a new partner</Link>
      </Section>
      <Section>
        <button onClick={loadPartnerOrgs}>Reload</button>
        <ErrorMsg msg={loadErrorMsg} />
        <PartnerOrgTable partnerOrgs={partnerOrgsList} />
      </Section>
    </DevPage>
  );
};
